module.exports = __webpack_public_path__ + "static/img/selection.363a948e.svg";